import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const MapIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <polyline
        fill="none"
        stroke={color}
        strokeWidth="2.4"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeLinejoin="miter"
        points="27,7.2 31,6 31,26 21,30 11,26 1,30 1,10 5,8.4"
      />
      <path
        fill="none"
        stroke={color}
        strokeWidth="2.4"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeLinejoin="miter"
        d="M23,7.818 C23,12.026,16,19,16,19S9,12.026,9,7.818C9,3.504,12.617,1,16,1S23,3.504,23,7.818z"
      />
      <circle
        fill="none"
        stroke={color}
        strokeWidth="2.4"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeLinejoin="miter"
        cx="16"
        cy="8"
        r="2"
      />
    </svg>
  );
};
